var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-container"},[_c('item-tip'),_c('div',{staticClass:"content-wrapper agenda-section"},[_c('tip-ete',{attrs:{"icon":2,"title":'峰会议程'}}),(_vm.agendaList && _vm.agendaList.length)?[_c('agenda-list',{attrs:{"list":_vm.agendaList}})]:[_c('div',{staticClass:"agenda-nodata center"},[_vm._v("敬请期待")])]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }